var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m12 l12"},[_c('div',{staticClass:"card card-loading"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v(_vm._s(_vm.message))])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-286dd5a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ContainerAlert/ContainerAlert.vue
// module id = null
// module chunks = 